import { ThemeProperties } from '../../core';

export interface ButtonTheme {
	baseFont: string;
	baseBorderRadius: string;
	baseFocusRingColor: string;
	baseIconMarginToText: string;

	primaryBackground: string;
	primaryHoverBackground: string;
	primaryActiveBackground: string;
	primaryTextColor: string;

	secondaryBorderColor: string;
	secondaryHoverBackground: string;
	secondaryActiveBackground: string;
	secondaryTextColor: string;

	ghostHoverBackground: string;
	ghostActiveBackground: string;
	ghostTextColor: string;

	dangerBackground: string;
	dangerHoverBackground: string;
	dangerActiveBackground: string;
	dangerTextColor: string;

	xSmallPaddingVertical: string;
	xSmallPaddingHorizontal: string;
	xSmallFont: string;
	xSmallMinWidth: string;
	xSmallMinHeight: string;
	xSmallIconPadding: string;
	xSmallIconSize: string;

	smallPaddingVertical: string;
	smallPaddingHorizontal: string;
	smallFont: string;
	smallMinWidth: string;
	smallMinHeight: string;
	smallIconPadding: string;
	smallIconSize: string;

	mediumPaddingVertical: string;
	mediumPaddingHorizontal: string;
	mediumFont: string;
	mediumMinWidth: string;
	mediumMinHeight: string;
	mediumIconPadding: string;
	mediumIconSize: string;

	largePaddingVertical: string;
	largePaddingHorizontal: string;
	largeFont: string;
	largeMinWidth: string;
	largeMinHeight: string;
	largeIconPadding: string;
	largeIconSize: string;

	xLargePaddingVertical: string;
	xLargePaddingHorizontal: string;
	xLargeFont: string;
	xLargeMinWidth: string;
	xLargeMinHeight: string;
	xLargeIconPadding: string;
	xLargeIconSize: string;
}
export const theme = new ThemeProperties('button');
